import { useContext } from 'react'

import ErrorPageContext from '@contexts/errorPageContext'

const useIsErrorPage = (): boolean => useContext(ErrorPageContext)

export default useIsErrorPage
